import "./uqual-card.scss";
import fileInvoiceDollar from "assets/images/v2/file-invoice-dollar.svg";
import Drawer, { DrawerType } from "components/ui/drawer/Drawer";
import { useState } from "react";
import nafLogoImage from "assets/images/newAmericanFundingWhiteBackground.svg";
import uqualLogoImage from "assets/images/uqual-logo.png";
import { Button } from "components/ui/button/Button";
import {
  CUSTOMER_REVIEW,
  ERROR_MESSAGE,
  INTERNAL_ERROR_MESSAGE,
  UQUAL_ADVISOR_CARD_SUBTITLE,
  UQUAL_ADVISOR_DRAWER_DISCLAIMER_TEXT,
  UQUAL_ADVISOR_DRAWER_DISCLAIMER,
  UQUAL_ADVISOR_DRAWER_REVIEW_CONTNT,
  UQUAL_BANNER_HEADER,
  UQUAL_CALL_DIRECTLY,
  UQUAL_CALL_DIRECTLY_2,
  UQUAL_MODAL_ACCEPT_BUTTON,
  UQUAL_MODAL_DECLINE_BUTTON,
  UQUAL_MODAL_DISCLAIMER,
  UQUAL_MODAL_HEADER,
  UQUAL_MODAL_SUBHEADER,
  UQUAL_MODAL_SUCCESS_BODY,
  UQUAL_MODAL_SUCCESS_DISCLAIMER_SECONDARY,
  UQUAL_MODAL_SUCCESS_HEADER,
} from "utilities/Constant";
import uqualIllustrationImage from "assets/images/v2/uqual-illustration.svg";
import chevronDown from "assets/images/v2/chevron-down.svg";
import { Spinner } from "components/v2/spinner/spinner";
import { ReactComponent as CircleCheck } from "assets/images/v2/circle-check.svg";
import PhoneIcon from "assets/images/v2/phone-icon.svg";
import { ReactComponent as StarIcon } from "assets/images/v2/star.svg";
import { useSubmitUqualReferalWithConsentMutation } from "pages/application/applicationService";
import { getNhDealApplicationId, getProspectId, setIsInitialUqualReferral, setSelfReferralInSession } from "features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import docErrorImg from "assets/images/v2/error-illustration.svg";

export default function UqualCard() {
  const [isShowUqualPanel, setIsShowUqualPanel] = useState(false);
  const [isShowDisclaimer, setIsShowDisclaimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isShowUqualPanelResponse, setisShowUqualPanelResponse] = useState(false);
  const [submitUqualReferal] = useSubmitUqualReferalWithConsentMutation();
  const nhDealAppId = useSelector(getNhDealApplicationId);
  const prospectId = useSelector(getProspectId);
  const dispatch = useDispatch();

  const handleUqualAdvisorPanelClick = () => {
    setisShowUqualPanelResponse(false);
    setLoading(false);
    setIsShowUqualPanel(true);
    setIsShowDisclaimer(false);
  };

  const handleSubmitUqualReferalCall = async () => {
    try {
      setLoading(true);
      const isSuccess = await submitUqualReferal({
        nhDealApplicationId: nhDealAppId,
        prospectId: prospectId,
      }).unwrap();
      setLoading(false);
      if (isSuccess) {
        setisShowUqualPanelResponse(true);
        dispatch(setSelfReferralInSession(true));
        dispatch(setIsInitialUqualReferral(true));
      } else {
        setShowError(true);
      }
    } catch {
      setLoading(false);
      setShowError(true);
    }
  };

  const renderUqualAdvisorResponsePanel = () => {
    return (
      <div className="uad__container">
        <div className="uad__section uad__section-center">
          <h5 className="uad__title uc-header uc-header-center">{UQUAL_MODAL_SUCCESS_HEADER}</h5>
          <p className="uad__sub-title uad__header-paragraph uc-paragraph">{UQUAL_MODAL_SUCCESS_BODY}</p>
        </div>
        <div className="uad__section uad__section-center uad__checkmark-wrapper">
          <div className="uad__checkmark-circle">
            <CircleCheck />
          </div>
        </div>
        <div className="uad__advisor-phone">
          <h6>Ready to Talk Now?</h6>
          <div>
            <img src={PhoneIcon} alt="Phone Icon" />
            <p className="uc-paragraph">
              {UQUAL_CALL_DIRECTLY} (720) 647-3161 {UQUAL_CALL_DIRECTLY_2}
            </p>
          </div>
        </div>
        <div className="uad__customer-review">
          <div className="uad__review-header">
            <h6>{CUSTOMER_REVIEW}</h6>
            <div className="uad__star-rating">
              {Array.from({ length: 5 }, (_, index) => (
                <StarIcon key={index} />
              ))}
            </div>
          </div>
          <div className="uad__review-content">
            <p className="uc-paragraph">{UQUAL_ADVISOR_DRAWER_REVIEW_CONTNT}</p>
            <h6>Vanessa R., Nevada</h6>
          </div>
        </div>
        <p className="uc-paragraph uad__notes">{UQUAL_MODAL_SUCCESS_DISCLAIMER_SECONDARY}</p>
        <div className="uad__footer uad__section uad__section-right uad__section-gap">
          <Button title={"Close"} type="round" variant="primary" size="medium" className="button-style" onClick={() => {setIsShowUqualPanel(false); dispatch(setIsInitialUqualReferral(false)); }} />
        </div>
      </div>
    );
  };

  const renderInitialContent = () => {
    return (
      <div className={`uad__container ${loading ? "uad__container--loading" : ""}`}>
        <div className="uad__section uad__section-center">
          <h5 className="uad__title uc-header uc-header-center">{UQUAL_MODAL_HEADER}</h5>
          <p className="uad__sub-title uad__header-paragraph uc-paragraph">{UQUAL_MODAL_SUBHEADER}</p>
        </div>
        <div className="uad__credit-report uad__section uad__section-center">
          <img src={uqualIllustrationImage} alt="Uqual Illustration" className="uad__credit-report-img" />
        </div>
        <div className="uad__disclaimer">
          <p className="uad__disclaimer-text uc-paragraph">{UQUAL_ADVISOR_DRAWER_DISCLAIMER_TEXT}</p>
          <div className="uad__disclaimer-wrapper">
            <button onClick={() => setIsShowDisclaimer(!isShowDisclaimer)}>
              <span>{UQUAL_ADVISOR_DRAWER_DISCLAIMER}</span>
              <img src={chevronDown} alt="Arrow Down" />
            </button>
            {isShowDisclaimer && <p className="uad__disclaimer-full uc-paragraph">{UQUAL_MODAL_DISCLAIMER}</p>}
          </div>
        </div>
        <div className="uad__footer uad__section uad__section-right uad__section-gap">
          <Button
            title={UQUAL_MODAL_DECLINE_BUTTON}
            type="round"
            variant="outline-primary"
            size="medium"
            className="button-style"
            onClick={() => setIsShowUqualPanel(false)}
          />
          <Button
            title={UQUAL_MODAL_ACCEPT_BUTTON}
            type="round"
            variant="primary"
            size="medium"
            className="button-style"
            onClick={() => handleSubmitUqualReferalCall()}
          />
        </div>
      </div>
    );
  };

  const renderErrorContent = () => {
    return (
      <div className="uad__container">
        <div className="uad__error-wrapper">
          <div className="uad__error-img">
            <img src={docErrorImg} alt="Internal error" />
          </div>
          <h5 className="uad__error-title">{ERROR_MESSAGE}</h5>
          <p className="uad__sub-title uad__header-paragraph uc-paragraph uad__error-message">{INTERNAL_ERROR_MESSAGE}</p>
        </div>
        <div className="uad__footer uad__section uad__section-right uad__section-gap">
          <Button
            title={"Close"}
            type="round"
            variant="primary"
            size="medium"
            className="button-style"
            onClick={() => {
              setShowError(false);
              setIsShowUqualPanel(false);
            }}
          />
        </div>
      </div>
    );
  };

  const renderUqualAdvisorPanel = () => {
    const getDrawerContent = () => {
      if (showError) {
        return renderErrorContent();
      }
      if (isShowUqualPanelResponse) {
        return renderUqualAdvisorResponsePanel();
      }
      return renderInitialContent();
    };

    return (
      <Drawer
        isOpen={isShowUqualPanel}
        onClose={() => {
          setIsShowUqualPanel(false);
          setShowError(false);
          dispatch(setIsInitialUqualReferral(false));
        }}
        type={DrawerType.UqualAdvisorCard}
        title={
          <div className="uqual-logos-container">
            <img src={nafLogoImage} alt="New American Funding Logo" />
            <div className="divider"></div>
            <img src={uqualLogoImage} alt="Uqual Logo" className="uqual-logo" />
          </div>
        }
        customCss="drawer-uqual-advisor"
      >
        {loading && (
          <div className="uad__spinner-overlay">
            <Spinner isApi />
          </div>
        )}
        {getDrawerContent()}
      </Drawer>
    );
  };

  return (
    <>
      <div className="uqual-card">
        <h6 className="uc-header">{UQUAL_BANNER_HEADER}</h6>
        <p className="uc-paragraph">{UQUAL_ADVISOR_CARD_SUBTITLE}</p>
        <img className="uqual-card__dollar-icon" alt="File Invoice Dollar icon" src={fileInvoiceDollar} />
        <div className="uqual-card__btn-container">
          <button className="uqual-card__btn" onClick={handleUqualAdvisorPanelClick}>
            Start Now
          </button>
        </div>
      </div>
      <div className="uqual-card-drawer">{isShowUqualPanel && renderUqualAdvisorPanel()}</div>
    </>
  );
}


